import { AssetPurchaseOrdersService } from '~/services/modules/assets/orders/asset-purchase-orders.service';
import { Component, Inject, ViewChild, ViewEncapsulation, ɵgetHostElement, ChangeDetectionStrategy } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ComboBoxComponent } from '@progress/kendo-angular-dropdowns';
import { Observable, Subscription } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { DataWithPagingMetadata } from '~/infrastructure/paging';
import { deactivationNoteSummary } from '~/models/modules/deactivationNote';
import { AccountsService } from '~/services/administration.ts/accounts';
import { UsersService } from '~/services/administration.ts/users';
import { AddressesService } from '~/services/modules/stocks/addresses';
import { CategoriesService } from '~/services/modules/stocks/categories';
import { CustomersService } from '~/services/modules/stocks/customers';
import { FilesService } from '~/services/modules/stocks/files';
import { StockItemsService } from '~/services/modules/stocks/items';
import { LocationTypesService } from '~/services/modules/stocks/location-types';
import { LocationsService } from '~/services/modules/stocks/locations';
import { DeactivationNotesService } from '~/services/modules/stocks/deactivationNotes';
import { UnitOfMeasuresService } from '~/services/modules/stocks/unit-of-measure';
import { VendorsService } from '~/services/modules/stocks/vendors';
import { ThemeManagerService } from '~/services/theme-manager';
import { LayoutManagerService, PORTAL_DATA } from '~/shared/components/layout/layout-manager';
import { LayoutComponent } from '../layout/layout.component';
import { SecurityService } from '../../../services/security.service';
import { DisposeToService } from '~/services/modules/stocks/dispose-to';
import { PurchaseOrdersService } from '~/services/modules/stocks/purchase-orders';
import { SalesOrdersService } from '~/services/modules/stocks/sales-orders';
import { DepartmentsService } from '~/services/modules/assets/department';
import { StatusesService } from '~/services/modules/assets/status';
import { ConditionsService } from '~/services/modules/assets/condition';
import { AssetTypeService } from '~/services/modules/assets/assetType';
import { AppRolesService } from '~/services/administration.ts/approles';
import { FacilityService } from '~/services/modules/stocks/facility';
import { FloorService } from '~/services/modules/stocks/floor';
import { BuildingService } from '~/services/modules/stocks/building';
import { AssetModelService } from '~/services/modules/assets/asset-model.service';
import { EntityStatus } from '~/shared/enums/itemsTypes';
import { AssetService } from '~/services/modules/assets/asset.service';
import { FundingSourceService } from '~/services/modules/assets/fundingSource';
import { SharedService } from '~/services/sharedService';
import { MultiSiteService } from '~/services/modules/common/multi-site.service';
import { ComponentBase } from '~/infrastructure/component-base';
import { AssetReservationService } from '~/services/modules/assets/transactions/asset-reservation.service';
import { ScheduleMaintenanceService } from '~/services/modules/assets/transactions/schedule-maintenance.service';


@Component({
    selector: 'app-stocks-deactivating-data',
    templateUrl: './deactivate-data.html',
    styleUrls: ['./deactivate-data.scss'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})

export class StocksDeactivatingDataComponent extends ComponentBase {

  @ViewChild('Kendo_Combo_Notes') KendoComboNotes: ComboBoxComponent;

  _isNew: boolean;
  _active: boolean;
  _theme: string;
  _note = new FormControl();
  _form: FormGroup;
  currentStep = 1;
  inavlidform: boolean = true;
  _itemId: any;
  _stockItem: any;
  _selectedAccounts: any = [];
  _showAccountsGrid = false;
  _notes: deactivationNoteSummary[];
  _pageName: string = '';
  _enableSiteSelection: boolean = true;
  _locationTypePage: boolean = false;
  _currentUser: any;
  _batch: any;
  _getNotesSubscription: Subscription
  constructor(private _themeManager: ThemeManagerService,
    private _layoutManager: LayoutManagerService,
    private _fb: FormBuilder,
    private _sharedService: SharedService,
    private _stockItemsService: StockItemsService,
    private _unitOfMeasuresService: UnitOfMeasuresService,
    private _accountsService: AccountsService,
    private _notesService: DeactivationNotesService,
    private _categoriesService: CategoriesService,
    private _customersService: CustomersService,
    private _vendorsService: VendorsService,
    private _departmentsService: DepartmentsService,
    private _conditionsService: ConditionsService,
    private _statusesService: StatusesService,
    private _addressesService: AddressesService,
    private _appRolesService: AppRolesService,
    private _filesService: FilesService,
    private _usersService: UsersService,
    private _locationsService: LocationsService,
    private _locationypesService: LocationTypesService,
    private _FacilityService: FacilityService,
    private _BuildingService: BuildingService,
    private _FloorService: FloorService,
    //private _gridLayoutManagerService: GridLayoutManagerService,
    private _layoutComponent: LayoutComponent,
    private _securityService: SecurityService,
    private _disposeToService: DisposeToService,
    private _poService: PurchaseOrdersService,
    private _soService: SalesOrdersService,
    private _assetTypeService: AssetTypeService,
    private _assetModelService: AssetModelService,
    private _assetService: AssetService,
    private _fundingSourceService: FundingSourceService,
    private _assetPurchaseOrdersService: AssetPurchaseOrdersService,
    private _assetReservationService: AssetReservationService,
    private _scheduleMaintenanceService: ScheduleMaintenanceService,
    private _sitesService: MultiSiteService,

    @Inject(PORTAL_DATA) public data: any) {
    super();

    if (data) {
      this._isNew = data.isNew;

      if (data.model.itemId) {
        this._itemId = data.model.itemId;
      }
      else {
        (data.model.batch)
      }

      this._batch = data.model.batch;

      this._pageName = data.model.pageName;
      this._active = true;
      this._locationTypePage = data.model.locationTypePage;
    }

    this._themeManager.themeChange.subscribe((data) => { this._theme = data; });
    this._layoutManager.applyOverly();
  }

  ngOnInit() {
    this._initForm();

    if (!this._batch)
      switch (this._pageName) {
        case 'stockItems':
          this._loadStockItem();

          break;
        case 'uom':
          this._loadUOMItem();
          break;
        case 'categories':
          this._loadCategories();
          break;
        case 'customers':
          this._loadCustomers();
          break;
        case 'vendors':
          this._loadVendors();
          break;
        case 'addresses':
          this._loadAddresses();
          break;
        case 'files':
          this._loadFiles();
          break;
        case 'documents':
          this._loadFiles();
          break;
        case 'videos':
          this._loadFiles();
          break;
        case 'users':
          this._loadUsers();
          break;
        case 'locations':
          this._loadLocations();
          break;
        case 'locationTypes':
          this._loadLocationTypes();
          break;
        case 'departments':
          this._loadDepatements();
          break;
        case 'facility': this._loadLocationTypes();
          break;

        case 'building': this._loadLocationTypes();
          break;

        case 'floor': this._loadLocationTypes();
          break;
        case 'disposeTo':
          this._loadDisposeTo();
          break;
        case 'purchaseOrders':
          this._loadPurchaseOrder();
          break;
        case 'salesOrders':
          this._loadSalesOrder();
          break;
        case 'appRoles':
          this._loadSecurityLevel();
          break;
        case 'asset-purchaseOrders':
          this._loadAssetPurchaseOrder();
          break;
        case 'asset-types':
          this._loadAssetType();
          break;
        case 'asset-models': {
          this._loadAssetModels();
          break;
        }
        case 'conditions': {
          this._loadConditions();
          break;
        }
        case 'assets': {
          this._loadAssets();
          break;
        }
        case 'fundingsource': {
          this._loadFundingSources();
          break;
        }
        case 'statuses': {
          this._loadAssetStatus();
          break;
        }
        case 'sites': {
          this._loadSites();
          break;
        }

        default:
          break;
      }
    this._loadNotes();
    // setTimeout(() => {
    //     this.KendoComboNotes.toggle(true);
    //     this.KendoComboNotes.focus();
    //     let NotesSelection = this.KendoComboNotes;
    //     NotesSelection['hostElement'].nativeElement.classList.add('focusedCombobox');
    // }, 300);

    this._currentUser = this._securityService.currentUser;
  }

  _loadNotes() {
    if (this._getNotesSubscription) {
      this._getNotesSubscription.unsubscribe();
    }

    this._getNotesSubscription = this._notesService.getNotesByPage(this._pageName).subscribe(res => {
      this._notes = res;
    });
  }

  _loadStockItem(): void {
    this._stockItemsService.getStockItem(this._itemId ?? this._batch).pipe(finalize(() => {
      this._showAccountsGrid = true;

      setTimeout(() => {
        this.KendoComboNotes.toggle(true);
        this.KendoComboNotes.focus();
        let NotesSelection = this.KendoComboNotes;
        ɵgetHostElement(NotesSelection).classList.add('focusedCombobox');
      }, 300);
    })).subscribe(res => {
      for (let i = 0; res.stockItemSites && i < res.stockItemSites.length; i++) {
        this._selectedAccounts.push({
          siteId: res.stockItemSites[i].site != null ? res.stockItemSites[i].site.id : null,
          accountId: res.stockItemSites[i].account.id
        });
      }
    });
  }

  _loadDepatements(): void {
    this._enableSiteSelection = false;
    this._departmentsService.getDepartmentById(this._itemId ?? this._batch).pipe(finalize(() => {
      this._showAccountsGrid = true;
      setTimeout(() => {
        this.KendoComboNotes.toggle(true);
        this.KendoComboNotes.focus();
        let NotesSelection = this.KendoComboNotes;
        ɵgetHostElement(NotesSelection).classList.add('focusedCombobox');
      }, 300);
    })).subscribe(res => {
      for (let i = 0; res.departmentAccounts && i < res.departmentAccounts.length; i++) {
        this._selectedAccounts.push(res.departmentAccounts[i].account.id);
      }
    });
  }

  _loadUOMItem(): void {
    this._enableSiteSelection = false;
    this._unitOfMeasuresService.getUnitOfMeasure(this._itemId ?? this._batch[0].id).pipe(finalize(() => {
      this._showAccountsGrid = true;
      setTimeout(() => {
        this.KendoComboNotes.toggle(true);
        this.KendoComboNotes.focus();
        ɵgetHostElement(this.KendoComboNotes).classList.add('focusedCombobox');
      }, 300);
    })).subscribe(res => {
      for (let i = 0; res.unitOfMeasureAccounts && i < res.unitOfMeasureAccounts.length; i++) {
        this._selectedAccounts.push(res.unitOfMeasureAccounts[i].account.id);
      }
    });
  }
  _loadAssetType(): void {
    this._enableSiteSelection = false;
    this._assetTypeService.getAssetTypeById(this._itemId ?? this._batch).pipe(
      finalize(() => {
        this._showAccountsGrid = true;
        setTimeout(() => {
          this.KendoComboNotes.toggle(true);
          this.KendoComboNotes.focus();
          ɵgetHostElement(this.KendoComboNotes).classList.add('focusedCombobox');
        }, 300);
      })).subscribe(res => {
        for (let i = 0; res.assetTypeAccounts && i < res.assetTypeAccounts.length; i++) {
          this._selectedAccounts.push(res.assetTypeAccounts[i].account.id);
        }
      });
  }
  _loadAssetModels(): void {
    this._assetModelService.getAssetModelById(this._itemId ?? this._batch).pipe(finalize(() => {
      this._showAccountsGrid = true;
      setTimeout(() => {
        this.KendoComboNotes.toggle(true);
        this.KendoComboNotes.focus();
        ɵgetHostElement(this.KendoComboNotes).classList.add('focusedCombobox');
      }, 300);
    })).subscribe(res => {
      for (let i = 0; res.modelSites && i < res.modelSites.length; i++) {
        if (!this._currentUser.isEnterprise) {
          this._selectedAccounts.push(res.modelSites[i].account.id);
        }
        else {
          this._selectedAccounts.push({
            siteId: res.modelSites[i].site != null ? res.modelSites[i].site.id : null,
            accountId: res.modelSites[i].account.id != null ? res.modelSites[i].account.id : null,
          });
        }
      }
    });
  }

  _loadConditions(): void {
    this._enableSiteSelection = false;
    this._conditionsService.getConditionById(this._itemId ?? this._batch).pipe(finalize(() => {
      this._showAccountsGrid = true;
      setTimeout(() => {
        this.KendoComboNotes.toggle(true);
        this.KendoComboNotes.focus();
        ɵgetHostElement(this.KendoComboNotes).classList.add('focusedCombobox');
      }, 300);
    })).subscribe(res => {
      for (let i = 0; res.conditionsAccounts && i < res.conditionsAccounts.length; i++) {
        this._selectedAccounts.push(res.conditionsAccounts[i].account.id);
      }
    });
  }

  _loadAssets(): void {
    // TODO:: THIS IS 3TAH I will Optimize it.
    this._assetService.getAssetById(this._itemId ?? this._batch).pipe(finalize(() => {
      this._showAccountsGrid = true;
      setTimeout(() => {
        this.KendoComboNotes.toggle(true);
        this.KendoComboNotes.focus();
        ɵgetHostElement(this.KendoComboNotes).classList.add('focusedCombobox');
      }, 300);
    })).subscribe(res => {
      for (let i = 0; res.assetSites && i < res.assetSites.length; i++) {
        if (!this._currentUser.isEnterprise) {
          this._selectedAccounts.push(res.assetSites[i].account.id);
        }
        else {
          this._selectedAccounts.push({
            siteId: res.assetSites[i].site != null ? res.assetSites[i].site.id : null,
            accountId: res.assetSites[i].account.id != null ? res.assetSites[i].account.id : null,
          });
        }
      }
    });
  }
  _loadFundingSources() {

    this._enableSiteSelection = false;
    this._fundingSourceService.getFundingSourceById(this._itemId ?? this._batch).pipe(finalize(() => {
      this._showAccountsGrid = true;
      setTimeout(() => {
        this.KendoComboNotes.toggle(true);
        this.KendoComboNotes.focus();
        ɵgetHostElement(this.KendoComboNotes).classList.add('focusedCombobox');
      }, 300);
    })).subscribe(res => {
      for (let i = 0; res.fundingSourceAccounts && i < res.fundingSourceAccounts.length; i++) {
        this._selectedAccounts.push(res.fundingSourceAccounts[i].account.id);
      }
    });
  }

  _loadAssetStatus() {

    this._enableSiteSelection = false;
    this._statusesService.getStatusById(this._itemId ?? this._batch).pipe(finalize(() => {
      this._showAccountsGrid = true;
      setTimeout(() => {
        this.KendoComboNotes.toggle(true);
        this.KendoComboNotes.focus();
        ɵgetHostElement(this.KendoComboNotes).classList.add('focusedCombobox');
      }, 300);
    })).subscribe(res => {
      for (let i = 0; res.assetStatusAccounts && i < res.assetStatusAccounts.length; i++) {
        this._selectedAccounts.push(res.assetStatusAccounts[i].account.id);
      }
    });
  }

  _loadSites() {
    setTimeout(() => {
      this.KendoComboNotes.toggle(true);
      this.KendoComboNotes.focus();

      let NotesSelection = this.KendoComboNotes;
      ɵgetHostElement(NotesSelection).classList.add('focusedCombobox');
    }, 300);
  }

  _loadCategories(): void {
    this._enableSiteSelection = false;
    this._categoriesService.getCategory(this._itemId ?? this._batch).pipe(finalize(() => {
      this._showAccountsGrid = true;
      setTimeout(() => {
        this.KendoComboNotes.toggle(true);
        this.KendoComboNotes.focus();
        let notesSelection = this.KendoComboNotes;
        ɵgetHostElement(notesSelection).classList.add('focusedCombobox');
      }, 300);
    })).subscribe(res => {
      for (let i = 0; res.categoryAccounts && i < res.categoryAccounts.length; i++) {
        if (this._currentUser.isEnterprise) {
          this._selectedAccounts.push(res.categoryAccounts[i].account.id);
        }
        else {
          this._selectedAccounts.push({
            //siteId:  res.categoryAccounts[i].site != null ? res.stockItemSites[i].site.id : null,
            accountId: res.categoryAccounts[i].account.id != null ? res.categoryAccounts[i].account.id : null,
          });
        }
        //this._selectedAccounts.push(res.categoryAccounts[i].account.id);
      }
    });
  }

  _loadCustomers(): void {
    this._customersService.getCustomer(this._itemId ?? this._batch).pipe(finalize(() => {
      this._showAccountsGrid = true;
      setTimeout(() => {
        this.KendoComboNotes.toggle(true);
        this.KendoComboNotes.focus();
        let NotesSelection = this.KendoComboNotes;
        ɵgetHostElement(NotesSelection).classList.add('focusedCombobox');
      }, 300);
    })).subscribe(res => {
      for (let i = 0; res.customerSites && i < res.customerSites.length; i++) {
        this._selectedAccounts.push({
          siteId: res.customerSites[i].site != null ? res.customerSites[i].site.id : null,
          accountId: res.customerSites[i].account.id
        });
      }
    });
  }

  _loadVendors(): void {
    this._vendorsService.getVendor(this._itemId ?? this._batch).pipe(finalize(() => {
      this._showAccountsGrid = true;
      setTimeout(() => {
        this.KendoComboNotes.toggle(true);
        this.KendoComboNotes.focus();
        let NotesSelection = this.KendoComboNotes;
        ɵgetHostElement(NotesSelection).classList.add('focusedCombobox');
      }, 300);
    })).subscribe(res => {
      for (let i = 0; res.vendorSites && i < res.vendorSites.length; i++) {
        this._selectedAccounts.push({
          siteId: res.vendorSites[i].site != null ? res.vendorSites[i].site.id : null,
          accountId: res.vendorSites[i].account.id
        });
      }
    });
  }

  _loadAddresses(): void {
    this._enableSiteSelection = false;
    this._addressesService.getAddress(this._itemId ?? this._batch).pipe(finalize(() => {
      this._showAccountsGrid = true;
      setTimeout(() => {
        this.KendoComboNotes.toggle(true);
        this.KendoComboNotes.focus();
        let notesSelection = this.KendoComboNotes;
        ɵgetHostElement(notesSelection).classList.add('focusedCombobox');
      }, 300);
    })).subscribe(res => {
      for (let i = 0; res.addressAccounts && i < res.addressAccounts.length; i++) {
        if (this._currentUser.isEnterprise) {
          this._selectedAccounts.push(res.addressAccounts[i].account.id);
        }
        else {
          this._selectedAccounts.push({
            accountId: res.addressAccounts[i].account.id
          });
        }
      }
    });
  }

  _loadSecurityLevel(): void {
    this._appRolesService.getAppRole(this._itemId ?? this._batch).pipe(finalize(() => {
      this._showAccountsGrid = true;
      setTimeout(() => {
        this.KendoComboNotes.toggle(true);
        this.KendoComboNotes.focus();
        let NotesSelection = this.KendoComboNotes;
        ɵgetHostElement(NotesSelection).classList.add('focusedCombobox');
      }, 300);
    })).subscribe(res => {
      for (let i = 0; res.AppRoleAccounts && i < res.AppRoleAccounts.length; i++) {
        this._selectedAccounts.push({
          accountId: res.AppRoleAccounts[i].AccountId
        });

        if (i == res.AppRoleAccounts.length - 1) {
          setTimeout(() => {
            this._enableSiteSelection = false;
          }, 500);
        }
      }
    });
  }

  _loadFiles(): void {
    this._enableSiteSelection = false;
    this._filesService.getFile(this._itemId ?? this._batch).pipe(finalize(() => {
      this._showAccountsGrid = true;
      setTimeout(() => {
        this.KendoComboNotes.toggle(true);
        this.KendoComboNotes.focus();
        let notesSelection = this.KendoComboNotes;
        ɵgetHostElement(notesSelection).classList.add('focusedCombobox');
      }, 300);
    })).subscribe(res => {
      for (let i = 0; res.fileAccounts && i < res.fileAccounts.length; i++) {
        if (res.fileAccounts[i].account) {
          //this._selectedAccounts.push(parseInt(res.fileAccounts[i].account.id));
          if (this._currentUser.isEnterprise) {
            this._selectedAccounts.push(parseInt(res.fileAccounts[i].account.id));
          }
          else {
            this._selectedAccounts.push({
              //siteId:  res.categoryAccounts[i].site != null ? res.stockItemSites[i].site.id : null,
              accountId: res.fileAccounts[i].account.id != null ? res.fileAccounts[i].account.id : null,
            });
          }
        }
      }
    });
  }

  _loadUsers(): void {
    this._usersService.getUser(this._itemId ?? this._batch[0].id).pipe(finalize(() => {
      this._showAccountsGrid = true;
      setTimeout(() => {
        this.KendoComboNotes.toggle(true);
        this.KendoComboNotes.focus();
        let NotesSelection = this.KendoComboNotes;
        ɵgetHostElement(NotesSelection).classList.add('focusedCombobox');
      }, 300);
    })).subscribe(res => {
      for (let i = 0; res.userSites && i < res.userSites.length; i++) {
        this._selectedAccounts.push({
          siteId: res.userSites[i].site != null ? res.userSites[i].site.id : null,
          accountId: res.userSites[i].account.id
        });
      }
    });
  }

  _loadLocations(): void {

    this._locationsService.getLocation(this._itemId ?? this._batch).pipe(finalize(() => {
      this._showAccountsGrid = true;
      setTimeout(() => {
        this.KendoComboNotes.toggle(true);
        this.KendoComboNotes.focus();
        let NotesSelection = this.KendoComboNotes;
        ɵgetHostElement(NotesSelection).classList.add('focusedCombobox');
      }, 300);
    })).subscribe(res => {
      for (let i = 0; res.locationSites && i < res.locationSites.length; i++) {
        this._selectedAccounts.push({
          siteId: res.locationSites[i].site != null ? res.locationSites[i].site.id : null,
          accountId: res.locationSites[i].account.id
        });
      }
    });
  }
  _loadDisposeTo(): void {
    this._disposeToService.getDisposeToById(this._itemId ?? this._batch).pipe(finalize(() => {
      this._showAccountsGrid = true;

      setTimeout(() => {
        this.KendoComboNotes.toggle(true);
        this.KendoComboNotes.focus();
        let NotesSelection = this.KendoComboNotes;
        ɵgetHostElement(NotesSelection).classList.add('focusedCombobox');
      }, 300);
    })).subscribe((res: any) => {
      this._selectedAccounts.push({
        accountId: res.site?.account?.id
      });
      setTimeout(() => {
        this._enableSiteSelection = false;
      }, 500);
    });
  }

  _loadPurchaseOrder(): void {
    this._poService.getPurchaseOrder(this._itemId)
      .pipe(finalize(() => {
        this._showAccountsGrid = true;
        setTimeout(() => {
          this.KendoComboNotes.toggle(true);
          this.KendoComboNotes.focus();
          let NotesSelection = this.KendoComboNotes;
          ɵgetHostElement(NotesSelection).classList.add('focusedCombobox')
        }, 300);
      }))
      .subscribe((res: any) => {
        this._selectedAccounts.push({
          accountId: res.site?.account?.id
        });
        setTimeout(() => {
          this._enableSiteSelection = false;
        }, 500);
      });
  }
  _loadSalesOrder(): void {
    this._soService.getSalesOrder(this._itemId)
      .pipe(finalize(() => {
        this._showAccountsGrid = true;
        setTimeout(() => {
          this.KendoComboNotes.toggle(true);
          this.KendoComboNotes.focus();
          let NotesSelection = this.KendoComboNotes;
          ɵgetHostElement(NotesSelection).classList.add('focusedCombobox')
        }, 300);
      }))
      .subscribe((res: any) => {
        this._selectedAccounts.push({
          accountId: res.site?.account?.id
        });
        setTimeout(() => {
          this._enableSiteSelection = false;
        }, 500);
      });
  }
  _loadLocationTypes(): void {
    if (!this._securityService.currentUser.isEnterprise) {
      setTimeout(() => {
        this.KendoComboNotes.toggle(true);
        this.KendoComboNotes.focus();
        let NotesSelection = this.KendoComboNotes;
        ɵgetHostElement(NotesSelection).classList.add('focusedCombobox');
      }, 300);
    }
    else {
      this._enableSiteSelection = false;
      this._locationypesService.getLocationType(this._itemId ?? this._batch[0].id)
        .pipe(
          finalize(() => {
            this._showAccountsGrid = true;
            setTimeout(() => {
              this.KendoComboNotes.toggle(true);
              this.KendoComboNotes.focus();
              ɵgetHostElement(this.KendoComboNotes).classList.add('focusedCombobox');
            }, 300);
          })
        )
        .subscribe(res => {
          for (let i = 0; res.locationTypeAccounts && i < res.locationTypeAccounts.length; i++) {
            this._selectedAccounts.push(res.locationTypeAccounts[i].account.id);
          }
        });
    }


  }
  _loadAssetPurchaseOrder(): void {
    this._assetPurchaseOrdersService.getPurchaseOrderById(this._itemId)
      .pipe(finalize(() => {
        this._showAccountsGrid = true;
        setTimeout(() => {
          this.KendoComboNotes.toggle(true);
          this.KendoComboNotes.focus();
          let NotesSelection = this.KendoComboNotes;
          ɵgetHostElement(NotesSelection).classList.add('focusedCombobox')
        }, 300);
      }))
      .subscribe((res: any) => {
        this._selectedAccounts.push({
          accountId: res.site?.account?.id
        });
        setTimeout(() => {
          this._enableSiteSelection = false;
        }, 500);
      });
  }
  _getAccounts = (params?: any, model?: any): Observable<DataWithPagingMetadata<any>> => {
    return this._accountsService.getAccounts(params, model);
  }

  _onCancel() {
    this._closeForm();
  }

  _closeForm() {
    this._active = false;
    //this._gridLayoutManagerService.setGridDataSubjects(this._pageName, true);
    // this._gridLayoutManagerService.setGridColumnSubjects(this._page);
    this._sharedService.ActivateOrDeactivate.emit(true);

    this.ngOnDestroy();
  }

  ngOnDestroy() {
    this._layoutManager.removeOverlay();
    // this._gridLayoutManagerService.destroy();
    if (this._getNotesSubscription)
      this._getNotesSubscription.unsubscribe();
  }

  _onStateChanges(e: any) {
    if (e === 'minimized') {
      this._layoutManager.removeOverlay();
    } else {
      this._layoutManager.applyOverly();
    }
  }

  _noteSubmited(event: any) {
    if (event) {
      this.inavlidform = false;
    } else {
      this.inavlidform = true;
    }
    setTimeout(() => {
      this.KendoComboNotes.toggle(false);
      this.currentStep = 3;
      let NotesSelection = this.KendoComboNotes;
      ɵgetHostElement(NotesSelection).classList.remove('focusedCombobox');
      let notesclosedvalue = this.KendoComboNotes;
      ɵgetHostElement(notesclosedvalue).children[0].classList.remove('k-state-focused');
    });
  }

  _skipNotes() {

    this.KendoComboNotes.toggle(false);
    this.currentStep = 3;
    let NotesSelection = this.KendoComboNotes;
    ɵgetHostElement(NotesSelection).classList.remove('focusedCombobox');
  }

  _noteFocusEvent() {
    setTimeout(() => {
      this.KendoComboNotes.toggle(true);
      this.KendoComboNotes.focus();
      this.currentStep = 1;
      let NotesSelection = this.KendoComboNotes;
      ɵgetHostElement(NotesSelection).classList.add('focusedCombobox');
    });
  }

  _notesComboOpening() {
    this.currentStep = 1;
    let notesclosedvalue = this.KendoComboNotes;
    ɵgetHostElement(notesclosedvalue).children[0].classList.add('k-state-focused');
  }

  _onDelete() {
    let obj = {};
    if (this._itemId) {
      obj = {
        id: this._itemId,
        noteId: this._note.value ? this._note.value.id : null,
        accountSites: this._selectedAccounts,
        ListOf: [this._itemId]
      };
    }
    else {
      obj = {
        id: null,
        batch: this._batch,
        ListOf: this._batch.map((a: any) => a.id),
        noteId: this._note.value ? this._note.value.id : null,
        accountSites: this._selectedAccounts,
        Batchstatus: EntityStatus.Deleted
      };

    }
    switch (this._pageName) {
      case 'stockItems':
        this._DeactivateStockItem(obj);
        break;
      case 'uom':
        this._DeactivateUOMItem(obj);
        break;
      case 'categories':
        this._DeactivateCategory(obj);
        break;
      case 'customers':
        this._DeactivateCustomers(obj);
        break;
      case 'vendors':
        this._DeactivateVendor(obj);
        break;
      case 'addresses':
        this._DeactivateAddress(obj);
        break;
      case 'files':
        this._DeactivateFiles(obj);
        break;
      case 'documents':
        this._DeactivateFiles(obj);
        break;
      case 'videos': /* To bo added */
        this._DeactivateFiles(obj);
        break;
      case 'users':
        this._DeactivateUser(obj);
        break;
      case 'persons':
        this._DeactivatePerson(obj);
        break;

      case 'locations':
        this._DeactivateLocation(obj);
        break;
      case 'locationTypes': this._DeactivateLocationType(obj); break;
      case 'facility': this._DeactivateFacility(obj); break;
      case 'building': this._DeactivateBuilding(obj); break;
      case 'floor': this._DeactivateFloor(obj); break;
      case 'disposeTo':
        this._DeactivateDisposeTo(obj);
        break;
      case 'purchaseOrders':
        this._DeactivatePurchaseOrders(obj);
        break;
      case 'asset-purchaseOrders':
        this._DeactivateAssetPurchaseOrders(obj);
        break;

      case 'salesOrders':
        this._DeactivateSalesOrders(obj);
        break;
      case 'departments':
        this._DeactivateDepartment(obj);
        break;
      case 'appRoles':
        this._DeactivateSecurityLevel(obj);
        break;
      case 'statuses':
        this._DeactivateStatus(obj);
        break;
      case 'conditions':
        this._DeactivateCondition(obj);
        break;
      case 'asset-types':
        this._DeactivateAssetType(obj);
        break;
      case 'asset-models':
        this._DeactivateAssetModel(obj);
        break;
      case 'assets':
        this._DeactivateAsset(obj);
        break;
      case 'asset-inventory':
        this._DeactivateAsset(obj);
        break;
      case 'fundingsource':
        this._DeactivateFundingSource(obj);
        break;
      case 'sites':
        //this._DeactivateSites(obj);
        this._validateDeactivateSite(obj);
        break;
      case 'asset-reservation':
        this._DeactivateAssetReservation(obj);
        break;
      case 'asset-reservation-list':
        this._DeactivateAssetReservation(obj);
        break;
      case 'schedule-maintenance':
      case 'ScheduleMaintenance':
        this._DeactivateScheduleMaintenance(obj);
        break;

      default:
        break;
    }
  }



  _DeactivateCondition(obj: any) {
    if (this._currentUser.isEnterprise) {
      (this._itemId ? this._conditionsService.deactivateCondition(obj) : this._conditionsService.deactivateConditionBatch(obj))

        .subscribe((response: any) => {
          //this._closeForm(); //temp
          if (response != null && response['message'] != null) {
            this._layoutComponent.openPopup({
              title: 'Alert',
              message: response['message'],
              withoutConfirm: true
            });
            if (response['close'] != null) {
              if (response['close'] == true) {
                this._closeForm();
              } else {
                return;
              }
            }
          }
        });
    }
    else {
      (this._itemId ? this._conditionsService.deactivateCondition(obj) : this._conditionsService.deactivateConditionBatch(obj))

        .subscribe((response: any) => {
          //this._closeForm(); //temp
          if (response != null && response['message'] != null) {
            this._layoutComponent.openPopup({
              title: 'Alert',
              message: response['message'],
              withoutConfirm: true
            });
            if (response['close'] != null) {
              if (response['close'] == true) {
                this._closeForm();
              } else {
                return;
              }
            }
          }
        });
    }
  }

  _DeactivateAssetType(obj: any) {
    if (this._currentUser.isEnterprise) {
      (this._itemId ? this._assetTypeService.deactivateAssetType(obj) : this._assetTypeService.deactivateAssetTypeBatch(obj))

        .subscribe((response: any) => {
          //this._closeForm(); //temp
          if (response != null && response['message'] != null) {
            this._layoutComponent.openPopup({
              title: 'Alert',
              message: response['message'],
              withoutConfirm: true
            });
            if (response['close'] != null) {
              if (response['close'] == true) {
                this._closeForm();
              } else {
                return;
              }
            }
          }
        });
    }
    else {
      (this._itemId ? this._assetTypeService.deactivateAssetType(obj) : this._assetTypeService.deactivateAssetTypeBatch(obj))

        .subscribe((response: any) => {
          //this._closeForm(); //temp
          if (response != null && response['message'] != null) {
            this._layoutComponent.openPopup({
              title: 'Alert',
              message: response['message'],
              withoutConfirm: true
            });
            if (response['close'] != null) {
              if (response['close'] == true) {
                this._closeForm();
              } else {
                return;
              }
            }
          }
        });
    }
  }

  _DeactivateAssetModel(obj: any) {
    if (this._currentUser.isEnterprise) {
      (this._itemId ? this._assetModelService.deactivateModel(obj) : this._assetModelService.deactivateModelBatch(obj))

        .subscribe((response: any) => {
          //this._closeForm(); //temp
          if (response != null && response['message'] != null) {
            this._layoutComponent.openPopup({
              title: 'Alert',
              message: response['message'],
              withoutConfirm: true
            });
            if (response['close'] != null) {
              if (response['close'] == true) {
                this._closeForm();
              } else {
                return;
              }
            }
          }
        });
    }
    else {
      (this._itemId ? this._assetModelService.deactivateModel(obj) : this._assetModelService.deactivateModelBatch(obj))

        .subscribe((response: any) => {
          //this._closeForm(); //temp
          if (response != null && response['message'] != null) {
            this._layoutComponent.openPopup({
              title: 'Alert',
              message: response['message'],
              withoutConfirm: true
            });
            if (response['close'] != null) {
              if (response['close'] == true) {
                this._closeForm();
              } else {
                return;
              }
            }
          }
        });
    }
  }

  _DeactivateAsset(obj: any) {
    let doDeactivate: boolean;
    let validateBatch = { ...obj };
    if (this._itemId) {
      validateBatch.isBatchValidate = false;
      validateBatch.batch = [];
      validateBatch.batch.push(obj);
    }
    else {
      validateBatch.isBatchValidate = true;
    }
    this._assetService.ValidateAssetForDeactivation(validateBatch)

      .subscribe((response) => {
        var _checkValid = response.data?.extraData ?? response.extraData;
        var _checkMsg = response.data?.message ?? response.message;
        if (_checkValid == false) {
          this._sharedService.okCloseClicked.subscribe((data: boolean) => {
            if (data == true) {
              this._doDeactivateAsset(obj);
            }
          });
          this._layoutComponent.openPopup({
            title: 'Warning',
            message: _checkMsg
          });
        }
        else {
          this._doDeactivateAsset(obj);
        }
      });
  }
  _doDeactivateAsset(obj: any) {
    if (this._currentUser.isEnterprise) { //just in case for the future :-)
      (this._itemId ? this._assetService.deactivateAsset(obj) : this._assetService.deactivateAssetBatch(obj))

        .subscribe((response: any) => {
          //this._closeForm(); //temp
          if (response != null && response['message'] != null) {
            this._layoutComponent.openPopup({
              title: 'Alert',
              message: response['message'],
              withoutConfirm: true
            });
            if (response['close'] != null) {
              if (response['close'] == true) {
                this._closeForm();
              } else {
                return;
              }
            }
          }
        });
    }
    else {
      (this._itemId ? this._assetService.deactivateAsset(obj) : this._assetService.deactivateAssetBatch(obj))

        .subscribe((response: any) => {
          //this._closeForm(); //temp
          if (response != null && response['message'] != null) {
            this._layoutComponent.openPopup({
              title: 'Alert',
              message: response['message'],
              withoutConfirm: true
            });
            if (response['close'] != null) {
              if (response['close'] == true) {
                this._closeForm();
              } else {
                return;
              }
            }
          }
        });
    }
  }
  _DeactivateFundingSource(obj: any) {
    if (this._currentUser.isEnterprise) { //just in case for the future :-)
      (this._itemId ? this._fundingSourceService.deactivateFundingSource(obj) : this._fundingSourceService.deactivateFundingSourceBatch(obj))

        .subscribe((response: any) => {
          //this._closeForm(); //temp
          if (response != null && response['message'] != null) {
            this._layoutComponent.openPopup({
              title: 'Alert',
              message: response['message'],
              withoutConfirm: true
            });
            if (response['close'] != null) {
              if (response['close'] == true) {
                this._closeForm();
              } else {
                return;
              }
            }
          }
        });
    }
    else {
      (this._itemId ? this._fundingSourceService.deactivateFundingSource(obj) : this._fundingSourceService.deactivateFundingSourceBatch(obj))

        .subscribe((response: any) => {
          //this._closeForm(); //temp
          if (response != null && response['message'] != null) {
            this._layoutComponent.openPopup({
              title: 'Alert',
              message: response['message'],
              withoutConfirm: true
            });
            if (response['close'] != null) {
              if (response['close'] == true) {
                this._closeForm();
              } else {
                return;
              }
            }
          }
        });
    }
  }
  _validateDeactivateSite(obj: any) {
    let doDeactivate: boolean;
    let validateBatch = { ...obj };
    if (this._itemId) {
      validateBatch.isBatchValidate = false;
      validateBatch.batch = [];
      validateBatch.batch.push(obj);
    }
    else {
      validateBatch.isBatchValidate = true;
    }
    this._sitesService.ValidateSiteForDeactivation(validateBatch)

      .subscribe((response) => {
        var _checkValid = response.data?.extraData ?? response.extraData;
        var _checkMsg = response.data?.message ?? response.message;
        if (_checkValid == false) {
          // this._sharedService.okCloseClicked.subscribe((data:boolean) => {
          //   if(data == true){
          //     this._DeactivateSites(obj);
          //   }
          // });
          this._layoutComponent.openPopup({
            title: 'Warning',
            message: _checkMsg,
            withoutConfirm: true
          });
        }
        else {
          this._DeactivateSites(obj);
        }
      });
  }
  _DeactivateSites(obj: any) {
    if (this._currentUser.isEnterprise) { //just in case for the future :-)
      (this._itemId ? this._sitesService.deactivateSite(obj) : this._sitesService.deactivateSiteBatch(obj))

        .subscribe((response: any) => {
          //this._closeForm(); //temp
          if (response != null && response['message'] != null) {
            this._layoutComponent.openPopup({
              title: 'Alert',
              message: response['message'],
              withoutConfirm: true
            });
            if (response['close'] != null) {
              if (response['close'] == true) {
                this._closeForm();
              } else {
                return;
              }
            }
          }
        });
    }
    else {
      (this._itemId ? this._sitesService.deactivateSite(obj) : this._sitesService.deactivateSiteBatch(obj))

        .subscribe((response: any) => {
          //this._closeForm(); //temp
          if (response != null && response['message'] != null) {
            this._layoutComponent.openPopup({
              title: 'Alert',
              message: response['message'],
              withoutConfirm: true
            });
            if (response['close'] != null) {
              if (response['close'] == true) {
                this._closeForm();
              } else {
                return;
              }
            }
          }
        });
    }
  }

  _DeactivateStatus(obj: any) {
    if (this._currentUser.isEnterprise) {
      (this._itemId ? this._statusesService.deactivateStatus(obj) : this._statusesService.deactivateStatusBatch(obj))

        .subscribe((response: any) => {
          //this._closeForm(); //temp
          if (response != null && response['message'] != null) {
            this._layoutComponent.openPopup({
              title: 'Alert',
              message: response['message'],
              withoutConfirm: true
            });
            if (response['close'] != null) {
              if (response['close'] == true) {
                this._closeForm();
              } else {
                return;
              }
            }
          }
        });
    }
    else {
      (this._itemId ? this._statusesService.deactivateStatus(obj) : this._statusesService.deactivateStatusBatch(obj))

        .subscribe((response: any) => {
          //this._closeForm(); //temp
          if (response != null && response['message'] != null) {
            this._layoutComponent.openPopup({
              title: 'Alert',
              message: response['message'],
              withoutConfirm: true
            });
            if (response['close'] != null) {
              if (response['close'] == true) {
                this._closeForm();
              } else {
                return;
              }
            }
          }
        });
    }
  }


  _DeactivateDepartment(obj: any) {
    if (this._currentUser.isEnterprise) {
      this._departmentsService.deactivateDepartment(obj)

        .subscribe((response: any) => {
          //this._closeForm(); //temp
          if (response != null && response['message'] != null) {
            this._layoutComponent.openPopup({
              title: 'Alert',
              message: response['message'],
              withoutConfirm: true
            });
            if (response['close'] != null) {
              if (response['close'] == true) {
                this._closeForm();
              } else {
                return;
              }
            }
          }
        });
    }
    else {
      if (obj.batch) {
        this._departmentsService.deactivatePatchDepartment(obj)

          .subscribe((response: any) => {
            //this._closeForm(); //temp
            if (response != null && response['message'] != null) {
              this._layoutComponent.openPopup({
                title: 'Alert',
                message: response['message'],
                withoutConfirm: true
              });
              if (response['close'] != null) {
                if (response['close'] == true) {
                  this._closeForm();
                } else {
                  return;
                }
              }
            }
          });
      }
      else {
        this._departmentsService.deactivateDepartment(obj)

          .subscribe((response: any) => {
            //this._closeForm(); //temp
            if (response != null && response['message'] != null) {
              this._layoutComponent.openPopup({
                title: 'Alert',
                message: response['message'],
                withoutConfirm: true
              });
              if (response['close'] != null) {
                if (response['close'] == true) {
                  this._closeForm();
                } else {
                  return;
                }
              }
            }
          });

      }
    }

  }

  _DeactivateStockItem(obj: any) {
    if (this._currentUser.isEnterprise) {
      this._stockItemsService.deactivateStockItem(obj)

        .subscribe((response: any) => {
          //this._closeForm(); //temp
          if (response != null && response['message'] != null) {
            this._layoutComponent.openPopup({
              title: 'Alert',
              message: response['message'],
              withoutConfirm: true
            });
            if (response['close'] != null) {
              if (response['close'] == true) {
                this._closeForm();
              } else {
                return;
              }
            }
          }
        });
    }
    else {
      (this._itemId ? this._stockItemsService.deactivateStockItem(obj) : this._stockItemsService.deactivateStockBatch(obj))

        .subscribe((response: any) => {
          //this._closeForm(); //temp
          if (response != null && response['message'] != null) {
            this._layoutComponent.openPopup({
              title: 'Alert',
              message: response['message'],
              withoutConfirm: true
            });
            if (response['close'] != null) {
              if (response['close'] == true) {
                this._closeForm();
              } else {
                return;
              }
            }
          }
        });
    }
  }

  _DeactivateUOMItem(obj: any) {
    if (this._currentUser.isEnterprise) {
      var accountsToSend: any[] = [];
      this._selectedAccounts.forEach((element: any) => {
        accountsToSend.push({ accountId: element });
      });
      obj.accountSites = accountsToSend;
      this._unitOfMeasuresService.deactivateUnitOfMeasure(obj)

        .subscribe((response: any) => {
          //this._closeForm(); //temp
          if (response != null && response['message'] != null) {
            this._layoutComponent.openPopup({
              title: 'Alert',
              message: response['message'],
              withoutConfirm: true
            });
            if (response['close'] != null) {
              if (response['close'] == true) {
                this._closeForm();
              } else {
                return;
              }
            }
          }
        });
    }
    else {
      (this._itemId ? this._unitOfMeasuresService.deactivateUnitOfMeasure(obj) : this._unitOfMeasuresService.deactivateUnitOfMeasureBatch(obj))

        .subscribe((response: any) => {
          //this._closeForm(); //temp
          if (response != null && response['message'] != null) {
            this._layoutComponent.openPopup({
              title: 'Alert',
              message: response['message'],
              withoutConfirm: true
            });
            if (response['close'] != null) {
              if (response['close'] == true) {
                this._closeForm();
              } else {
                return;
              }
            }
          }
        });
    }
  }
  _DeactivateCategory(obj: any) {
    if (this._currentUser.isEnterprise) {
      var accountsToSend: any[] = [];
      this._selectedAccounts.forEach((element: any) => {
        accountsToSend.push({ accountId: element });
      });
      obj.accountSites = accountsToSend;
      this._categoriesService.deactivateCategory(obj)

        .subscribe((response: any) => {
          //this._closeForm(); //temp
          if (response != null && response['message'] != null) {
            this._layoutComponent.openPopup({
              title: 'Alert',
              message: response['message'],
              withoutConfirm: true
            });
            if (response['close'] != null) {
              if (response['close'] == true) {
                this._closeForm();
              } else {
                return;
              }
            }
          }
        });
    } else {
      (this._itemId ? this._categoriesService.deactivateCategory(obj) : this._categoriesService.deactivatecategoryBatch(obj))

        .subscribe((response: any) => {
          //this._closeForm(); //temp
          if (response != null && response['message'] != null) {
            this._layoutComponent.openPopup({
              title: 'Alert',
              message: response['message'],
              //message: "Deactivated Successfully",
              withoutConfirm: true
            });
            if (response['close'] != null) {
              if (response['close'] == true) {
                this._closeForm();
              } else {
                return;
              }
            }
          }
        });
    }
  }

  _DeactivateCustomers(obj: any) {
    if (this._currentUser.isEnterprise) {
      this._customersService.deactivateCustomer(obj)

        .subscribe((response: any) => {
          //this._closeForm(); //temp
          if (response != null && response['message'] != null) {
            this._layoutComponent.openPopup({
              title: 'Alert',
              message: response['message'],
              withoutConfirm: true
            });
            if (response['close'] != null) {
              if (response['close'] == true) {
                this._closeForm();
              } else {
                return;
              }
            }
          }
        });
    }
    else {
      (this._itemId ? this._customersService.deactivateCustomer(obj) : this._customersService.deactivateCutemerBatch(obj))

        .subscribe((response: any) => {
          //this._closeForm(); //temp
          if (response != null && response['message'] != null) {
            this._layoutComponent.openPopup({
              title: 'Alert',
              message: response['message'],
              withoutConfirm: true
            });
            if (response['close'] != null) {
              if (response['close'] == true) {
                this._closeForm();
              } else {
                return;
              }
            }
          }
        });
    }

  }
  _DeactivateVendor(obj: any) {
    if (this._currentUser.isEnterprise) {
      this._vendorsService.deactivateVendor(obj)

        .subscribe((response: any) => {
          if (response != null && response.data != null && response.data['message'] != null) {
            this._layoutComponent.openPopup({
              title: 'Alert',
              message: response.data['message'],
              withoutConfirm: true
            });
            if (response.data['close'] != null) {
              if (response.data['close'] == true) {
                this._closeForm();
              } else {
                return;
              }
            }
          }
          else if (response != null && response['message'] != null) {
            this._layoutComponent.openPopup({
              title: 'Alert',
              message: response['message'],
              withoutConfirm: true
            });
            if (response['close'] != null) {
              if (response['close'] == true) {
                this._closeForm();
              } else {
                return;
              }
            }
          }
          else {
            this._closeForm();
          }
        });
    }
    else {
      (this._itemId ? this._vendorsService.deactivateVendor(obj) : this._vendorsService.deactivateVendorBatch(obj))

        .subscribe((response: any) => {
          if (response != null && response.data != null && response.data['message'] != null) {
            this._layoutComponent.openPopup({
              title: 'Alert',
              message: response.data['message'],
              withoutConfirm: true
            });
            if (response.data['close'] != null) {
              if (response.data['close'] == true) {
                this._closeForm();
              } else {
                return;
              }
            }
          }
          else if (response != null && response['message'] != null) {
            this._layoutComponent.openPopup({
              title: 'Alert',
              message: response['message'],
              withoutConfirm: true
            });
            if (response['close'] != null) {
              if (response['close'] == true) {
                this._closeForm();
              } else {
                return;
              }
            }
          }
          else {
            this._closeForm();
          }
        });
    }
  }
  _DeactivateUser(obj: any) {
    (this._itemId ? this._usersService.deactivateUser(obj) : this._usersService.deactivateUserBatch(obj))

      .subscribe((response: any) => {
        //this._closeForm(); //temp
        if (response != null && response['message'] != null) {
          this._layoutComponent.openPopup({
            title: 'Alert',
            message: response['message'],
            withoutConfirm: true
          });
          if (response['close'] != null) {
            if (response['close'] == true) {
              this._closeForm();
            } else {
              return;
            }
          }
        }
      });
  }
  _DeactivatePerson(obj: any) {
    (this._itemId ? this._usersService.deactivatePerson(obj) : this._usersService.deactivatePersonBatch(obj))

      .subscribe((response: any) => {
        //this._closeForm(); //temp
        if (response != null && response['message'] != null) {
          this._layoutComponent.openPopup({
            title: 'Alert',
            message: response['message'],
            withoutConfirm: true
          });
          if (response['close'] != null) {
            if (response['close'] == true) {
              this._closeForm();
            } else {
              return;
            }
          }
        }
      });
  }
  _DeactivateAddress(obj: any) {
    if (this._currentUser.isEnterprise) {
      var accountsToSend: any[] = [];
      this._selectedAccounts.forEach((element: any) => {
        accountsToSend.push({ accountId: element });
      });
      obj.accountSites = accountsToSend;
      this._addressesService.deactivateAddress(obj)

        .subscribe((response: any) => {
          if (response != null && response.data != null && response.data['message'] != null) {
            this._layoutComponent.openPopup({
              title: 'Alert',
              message: response.data['message'],
              withoutConfirm: true
            });
            if (response.data['close'] != null) {
              if (response.data['close'] == true) {
                this._closeForm();
              } else {
                return;
              }
            }
          }
          else if (response != null && response['message'] != null) {
            this._layoutComponent.openPopup({
              title: 'Alert',
              message: response['message'],
              withoutConfirm: true
            });
            if (response['close'] != null) {
              if (response['close'] == true) {
                this._closeForm();
              } else {
                return;
              }
            }
          }
          else {
            this._closeForm();
          }
        });
    }
    else {
      (this._itemId ? this._addressesService.deactivateAddress(obj) : this._addressesService.deactivateAddressBatch(obj))

        .subscribe((response: any) => {
          if (response != null && response.data != null && response.data['message'] != null) {
            this._layoutComponent.openPopup({
              title: 'Alert',
              message: response.data['message'],
              withoutConfirm: true
            });
            if (response.data['close'] != null) {
              if (response.data['close'] == true) {
                this._closeForm();
              } else {
                return;
              }
            }
          }
          else if (response != null && response['message'] != null) {
            this._layoutComponent.openPopup({
              title: 'Alert',
              message: response['message'],
              withoutConfirm: true
            });
            if (response['close'] != null) {
              if (response['close'] == true) {
                this._closeForm();
              } else {
                return;
              }
            }
          }
          else {
            this._closeForm();
          }
        });
    }
  }
  _DeactivateFiles(obj: any) {
    if (this._currentUser.isEnterprise) {
      this._filesService.deactivateFiles(obj)

        .subscribe((response: any) => {
          //this._closeForm(); //temp
          if (response != null && response['message'] != null) {
            this._layoutComponent.openPopup({
              title: 'Alert',
              message: response['message'],
              withoutConfirm: true
            });
            if (response['close'] != null) {
              if (response['close'] == true) {
                this._closeForm();
              } else {
                return;
              }
            }
          }
        });
    }
    else {
      (this._itemId ? this._filesService.deactivateFiles(obj) : this._filesService.deactivateFileBatch(obj))

        .subscribe((response: any) => {
          //this._closeForm(); //temp
          if (response != null && response['message'] != null) {
            this._layoutComponent.openPopup({
              title: 'Alert',
              message: response['message'],
              withoutConfirm: true
            });
            if (response['close'] != null) {
              if (response['close'] == true) {
                this._closeForm();
              } else {
                return;
              }
            }
          }
        });
    }
  }
  _DeactivateLocation(obj: any) {
    (this._itemId ? this._locationsService.deactivateLocation(obj) : this._locationsService.deactivateLocationBatch(obj))

      .subscribe((response: any) => {
        //this._closeForm(); //temp
        if (response != null && response['message'] != null) {
          this._layoutComponent.openPopup({
            title: 'Alert',
            message: response['message'],
            withoutConfirm: true
          });
          if (response['close'] != null) {
            if (response['close'] == true) {
              this._closeForm();
            } else {
              return;
            }
          }
        }
      });
  }
  _DeactivateDisposeTo(obj: any) {
    (this._itemId ? this._disposeToService.deletedisposeTo(obj) : this._disposeToService.deactivateDisposeToBatch(obj))

      .subscribe((response: any) => {
        //this._closeForm();
        if (response != null && response['message'] != null) {
          this._layoutComponent.openPopup({
            title: 'Alert',
            message: response['message'],
            withoutConfirm: true
          });
          if (response['close'] != null) {
            if (response['close'] == true) {
              this._closeForm();
            } else {
              return;
            }
          }
        }
      });
  }
  _DeactivatePurchaseOrders(obj: any) {

    this._poService.reactivateDeactivateBatchPurchaseOrder(obj)

      .subscribe((response: any) => {
        //this._closeForm();
        if (response != null && response['message'] != null) {
          this._layoutComponent.openPopup({
            title: 'Alert',
            message: response['message'],
            withoutConfirm: true
          });
          if (response['close'] != null) {
            if (response['close'] == true) {
              this._closeForm();
            } else {
              return;
            }
          }
        }
      });
  }
  _DeactivateSalesOrders(obj: any) {
    this._soService.activedeactivateSaleOrderBatch(obj)

      .subscribe((response: any) => {
        //this._closeForm();
        if (response != null && response['message'] != null) {
          this._layoutComponent.openPopup({
            title: 'Alert',
            message: response['message'],
            withoutConfirm: true
          });
          if (response['close'] != null) {
            if (response['close'] == true) {
              this._closeForm();
            } else {
              return;
            }
          }
        }
      });
  }
  _DeactivateLocationType(obj: any) {
    if (this._securityService.currentUser.isEnterprise) {
      obj.accountSites = [];
    }
    (this._locationypesService.activatedeactivateLocationTypeBatch(obj))

      .subscribe((response: any) => {
        //this._closeForm();
        if (response.data['message'] != null) {
          //  setTimeout(() => {     //  }, 300);
          this._layoutComponent.openPopup({
            title: 'Alert',
            message: response.data['message'],
            withoutConfirm: true
          });

          if (response.data['close'] != null) {
            if (response.data['close'] == true) {
              this._closeForm();
            } else {
              return;
            }
          }
        }
        else if (response['message'] != null) {
          this._layoutComponent.openPopup({
            title: 'Alert',
            message: response['message'],
            withoutConfirm: true
          });
          if (response['close'] != null) {
            if (response['close'] == true) {
              this._closeForm();
            } else {
              return;
            }
          }
        }
      });
  }

  _DeactivateFacility(obj: any) {
    (this._itemId ? this._FacilityService.deactivateFacility(obj) :
      this._FacilityService.deactivateFacilityBatch(obj))

      .subscribe((response: any) => {
        //this._closeForm(); //temp
        if (response != null && response['message'] != null) {
          this._layoutComponent.openPopup({
            title: 'Alert',
            message: response['message'],
            withoutConfirm: true
          });
          if (response['close'] != null) {
            if (response['close'] == true) {
              this._closeForm();
            } else {
              return;
            }
          }
        }
      });


  }
  _DeactivateFloor(obj: any) {
    this._FloorService.reactivateAnddeactivateFloorBatch(obj)

      .subscribe((response: any) => {
        //this._closeForm();
        if (response != null && response['message'] != null) {
          this._layoutComponent.openPopup({
            title: 'Alert',
            message: response['message'],
            withoutConfirm: true
          });
          if (response['close'] != null) {
            if (response['close'] == true) {
              this._closeForm();
            } else {
              return;
            }
          }
        }
      });


  }
  _DeactivateBuilding(obj: any) {
    this._BuildingService.activateAnddeactivateBuildingBatch(obj)

      .subscribe((response: any) => {
        //this._closeForm(); //temp
        if (response != null && response['message'] != null) {
          this._layoutComponent.openPopup({
            title: 'Alert',
            message: response['message'],
            withoutConfirm: true
          });
          if (response['close'] != null) {
            if (response['close'] == true) {
              this._closeForm();
            } else {
              return;
            }
          }
        }
      });


  }
  _DeactivateSecurityLevel(obj: any) {

    if (this._currentUser.isEnterprise) {
      this._appRolesService.deactivateAppRole(obj)

        .subscribe((response: any) => {
          //this._closeForm(); //temp
          if (response != null && response['message'] != null) {
            this._layoutComponent.openPopup({
              title: 'Alert',
              message: response['message'],
              withoutConfirm: true
            });
            if (response['close'] != null) {
              if (response['close'] == true) {
                this._closeForm();
              } else {
                return;
              }
            }
          }
        });
    }
    else {
      (this._itemId ? this._appRolesService.deactivateAppRole(obj) : null)

        .subscribe((response: any) => {
          //this._closeForm(); //temp
          if (response != null && response['message'] != null) {
            this._layoutComponent.openPopup({
              title: 'Alert',
              message: response['message'],
              withoutConfirm: true
            });
            if (response['close'] != null) {
              if (response['close'] == true) {
                this._closeForm();
              } else {
                return;
              }
            }
          }
        });
    }
  }

  _DeactivateAssetPurchaseOrders(obj: any) {

    this._assetPurchaseOrdersService.reactivateDeactivateBatchPurchaseOrder(obj)

      .subscribe((response: any) => {
        //this._closeForm();
        if (response != null && response['message'] != null) {
          this._layoutComponent.openPopup({
            title: 'Alert',
            message: response['message'],
            withoutConfirm: true
          });
          if (response['close'] != null) {
            if (response['close'] == true) {
              this._closeForm();
            } else {
              return;
            }
          }
        }
      });
  }

  _DeactivateAssetReservation(obj: any) {

    this._assetReservationService.reactivateDeactivateBatchAssetReservation(obj)

      .subscribe((response: any) => {
        //this._closeForm();
        if (response != null && response['message'] != null) {
          this._layoutComponent.openPopup({
            title: 'Alert',
            message: response['message'],
            withoutConfirm: true
          });
          if (response['close'] != null) {
            if (response['close'] == true) {
              this._closeForm();
            } else {
              return;
            }
          }
        }
      });
  }

  _DeactivateScheduleMaintenance(obj: any) {
    this._scheduleMaintenanceService.batchActivateDeactivate(obj)
      .subscribe((response: any) => {
        if (response != null && response['message'] != null) {
          this._layoutComponent.openPopup({
            title: 'Alert',
            message: response['message'],
            withoutConfirm: true
          });
          if (response['close'] != null) {
            if (response['close'] == true) {
              this._closeForm();
            } else {
              return;
            }
          }
        }
      });
  }


  private _initForm() {
    this._form = this._fb.group({
      note: ['', [Validators.required]],
    });
  }
}
